// Discount badge data from the tags the Product Discounts app stamps on a product:
// `discounted` and `discount:{percent}`. Mirrors snippets/discount-badge.liquid.

export const DISCOUNT_TAG = 'discounted';
export const DISCOUNT_VALUE_TAG_PREFIX = 'discount:';

// Rebuy returns tags either as an array or as a comma-separated string.
function normalizeTags(product) {
    let tags = product && product.tags;
    if (typeof tags === 'string') {
        tags = tags.split(',');
    }

    if (!Array.isArray(tags)) {
        return [];
    }

    return tags.filter((tag) => typeof tag === 'string').map((tag) => tag.trim().toLowerCase());
}

// { discounted, percent } — percent is the raw tag value (e.g. "15", "12.5") or ''.
export function getProductDiscount(product) {
    const result = {discounted: false, percent: ''};

    try {
        normalizeTags(product).forEach((tag) => {
            if (tag === DISCOUNT_TAG) {
                result.discounted = true;
            } else if (tag.startsWith(DISCOUNT_VALUE_TAG_PREFIX)) {
                const percent = tag.slice(DISCOUNT_VALUE_TAG_PREFIX.length).trim();
                if (percent) {
                    result.percent = percent;
                }
            }
        });
    } catch (error) {
        // Never let bad data break a card render.
    }

    return result;
}

// "15% OFF", "Sale" when only the `discounted` tag is present, or '' when not discounted.
export function getDiscountLabel(product) {
    const {discounted, percent} = getProductDiscount(product);

    if (percent) {
        return `${percent}% OFF`;
    }

    return discounted ? 'Sale' : '';
}
